<pxc-paginated-list *transloco="let t">
  @if (sequencesCollection$ | async; as sequencesCollection) {
    @switch (mode) {
      @case (SequencePreviewMode.ROW) {
        <div class="flex flex-col items-stretch gap-2">
          @for (sequence of sequencesCollection; track sequence.sequenceInstance.id; let idx = $index) {
            <pxc-sequence-preview
              class="animate-in fade-in slide-in-from-top-1"
              [actions]="actions"
              [attr.data-testid]="'seq-' + sequence.sequenceInstance.id"
              [id]="'seq-' + idx"
              [isPatientClickable]="isPatientClickable"
              [sequence]="sequence"
              [showActions]="showActions"
              [showPatient]="showPatient"
              (mediaClicked)="sequenceMediaClicked.emit($event)">
              <ng-container
                *ngTemplateOutlet="sequenceActionsTemplate; context: { sequence: sequence, icons: false }" />
            </pxc-sequence-preview>
          } @empty {
            <pxc-lottie-label
              animation="sequenceEmpty"
              data-testid="no-sequence-message"
              [message]="t('Vous n\'avez aucune photo')" />
          }
        </div>
      }
      @case (SequencePreviewMode.TILE) {
        <div class="grid justify-items-center gap-x-3 gap-y-6 grid-cols-2 lg:grid-cols-3">
          @for (sequence of sequencesCollection; track sequence.sequenceInstance.id; let idx = $index) {
            <pxc-sequence-preview-tile
              class="isolate w-full max-w-96 animate-in fade-in slide-in-from-top-1"
              id="seq-{{ idx }}"
              [actions]="actions"
              [attr.data-testid]="'seq-' + sequence.sequenceInstance.id"
              [isPatientClickable]="isPatientClickable"
              [sequence]="sequence"
              [showActions]="showActions"
              [showPatient]="showPatient"
              (mediaClicked)="sequenceMediaClicked.emit($event)">
              <ng-container
                *ngTemplateOutlet="sequenceActionsTemplate; context: { sequence: sequence, iconOnly: true }" />
            </pxc-sequence-preview-tile>
          } @empty {
            <pxc-lottie-label
              animation="sequenceEmpty"
              class="col-span-3"
              data-testid="no-sequence-message"
              [message]="t('Vous n\'avez aucune photo')" />
          }
        </div>
      }
    }
  }

  <ng-template #sequenceActionsTemplate let-iconOnly="iconOnly" let-sequence="sequence">
    @if (sequence.sequenceInstance.description) {
      <pxc-sequence-description-dialog [description]="sequence.sequenceInstance.description" [iconOnly]="iconOnly" />
    }
    @if (context === SequenceContext.SEQUENCE) {
      @if (iconOnly) {
        <button
          appearance="flat-grayscale"
          iconStart="telemonitoring"
          size="s"
          tuiIconButton
          tuiTheme="dark"
          type="button"
          [sequenceTelemonitoringLink]="sequence"
          [tuiHint]="t('Télésuivi')"></button>
      } @else {
        <a tuiLink [sequenceTelemonitoringLink]="sequence">
          {{ t('Télésuivi') }}
        </a>
      }
    }
    @if (iconOnly) {
      <button
        appearance="flat-grayscale"
        iconStart="@tui.chart-line"
        size="s"
        tuiIconButton
        tuiTheme="dark"
        type="button"
        [sequenceSadmLink]="sequence"
        [tuiHint]="t('Analyse de la lésion')"></button>
    } @else {
      <a tuiLink [sequenceSadmLink]="sequence">
        {{ t('Analyse de la lésion') }}
      </a>
    }
    @if (
      sequence.sequenceInstance.patientFormAnswerId && sequence.sequenceInstance.creatorType === CreatorType.BY_PATIENT
    ) {
      @let riskIndicatorsCount = sequence.sequenceInstance.riskIndicatorsCount;
      <a class="flex items-center gap-1.5 no-underline!" tuiLink (click)="openPatientFormAnswer(sequence)">
        @if (iconOnly) {
          <button
            appearance="flat-grayscale"
            iconStart="@tui.file-text"
            size="s"
            tuiIconButton
            tuiTheme="dark"
            type="button"
            [tuiHint]="t('Questionnaire')"></button>
        } @else {
          {{ t('Questionnaire') }}
        }
        @if (riskIndicatorsCount > 0) {
          <span appearance="negative" size="xs" tuiChip tuiHintAppearance="negative" [tuiHint]="riskIndicatorHint">
            <div class="h-2 w-2 rounded-full bg-background-error-solid"></div>
            {{ riskIndicatorsCount }}
          </span>
        }
        <ng-template #riskIndicatorHint>
          {{
            t(
              '{count, plural, =0 { Ce questionnaire ne contient aucun indicateur de risque } one { Ce questionnaire contient 1 indicateur de risque } other { Ce questionnaire contient # indicateurs de risque } }',
              {
                count: riskIndicatorsCount,
              }
            )
          }}
        </ng-template>
      </a>
    }
  </ng-template>
</pxc-paginated-list>
